export type ResumeSession = {
  token: string;
  roomId: string;
  userId: string;
};

/** 上次离开时是否停在雅间 / 对局。大厅等界面重载不得据此拉回房间。 */
export type UiStay = "away" | "room";

const KEY = "gaoya.session";
const STAY_KEY = "gaoya.stay";
const MAX_AGE_MS = 6 * 60 * 60 * 1000;

export function loadStay(getStorage: (key: string) => string | null): UiStay {
  const raw = getStorage(STAY_KEY);
  if (raw === "room") return "room";
  if (raw === "away") return "away";
  return loadResume(getStorage) ? "room" : "away";
}

export function saveStay(setStorage: (key: string, value: string) => void, stay: UiStay): void {
  setStorage(STAY_KEY, stay);
}

export function loadResume(getStorage: (key: string) => string | null): ResumeSession | null {
  const raw = getStorage(KEY);
  if (!raw) return null;
  try {
    const o = JSON.parse(raw) as { token?: unknown; roomId?: unknown; userId?: unknown; at?: unknown };
    const token = typeof o.token === "string" ? o.token : "";
    const roomId = typeof o.roomId === "string" ? o.roomId : "";
    const userId = typeof o.userId === "string" ? o.userId : "";
    if (!token || !roomId) return null;
    if (typeof o.at === "number" && Date.now() - o.at > MAX_AGE_MS) return null;
    return { token, roomId, userId };
  } catch {
    return null;
  }
}

export function saveResume(setStorage: (key: string, value: string) => void, session: ResumeSession): void {
  if (!session.token || !session.roomId) return;
  setStorage(KEY, JSON.stringify({ ...session, at: Date.now() }));
}

export function clearResume(setStorage: (key: string, value: string) => void): void {
  setStorage(KEY, "");
}
